import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _10M_BLUE_CARBON:Partial<EcosystemServiceModel> ={
  id:'blue-carbon',
  pos:10,
  image: "/images/ecoservices/blue_carbon_s.png",
  code: ["2.2.6.1"],
  unit:'CO₂ absorption',
  assetType:'species',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "tons",
      element: "CO₂ absorved",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ],
  hasInitialValue:true,
  initialQty:'carbonStock',
  restrictions:{
    onlyAllowed:['marine']
  }

}
